<template>
    <div class="confirm-type-clone-wrapper">
        <p v-if="showContent" class="mt-6 mb-16 text-center">
            {{ $t('§ui_message.clone_unit_type_with_rvt_warning') }}
        </p>

        <div class="flex gap-2">
            <CoreButton
                v-if="hasResidualValuesTable"
                ref="clone-with-rvt-button"
                @click="handleCloneWithRVT"
                :disabled="executing"
                :loading="executing"
                :label="$t('§ui_button.clone_with_rvt')"
                variant="primary"
                icon="pi-clone"
            />

            <CoreButton
                v-if="hasResidualValuesTable"
                @click="handleCloneWithoutRVT"
                :disabled="executing"
                :label="$t('§ui_button.clone_without_rvt')"
                variant="secondary"
                icon="pi-clone"
            />

            <CoreButton
                v-if="!hasResidualValuesTable"
                ref="clone-button"
                @click="handleClone"
                :disabled="executing"
                :loading="executing"
                :label="$t('§ui_button.clone')"
                variant="primary"
                icon="pi-clone"
            />

            <CoreButton
                icon="pi-times"
                variant="tertiary"
                :disabled="executing"
                :label="$t('§ui_button.cancel')"
                @click="handleClose"
            />
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import { useUnitTypeStore } from '@/stores/unitType'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'ConfirmTypeClone',

    components: {
        CoreButton,
    },

    data() {
        return {
            modalStore: useModalStore(),
            unitTypeStore: useUnitTypeStore(),
            executing: false,
        }
    },

    computed: {
        hasResidualValuesTable() {
            return this.unitTypeStore.unitTypeData.residual_values_table !== null
        },

        showContent() {
            return this.hasResidualValuesTable
        },
    },

    mounted() {
        if (this.$refs['clone-with-rvt-button']) {
            this.$refs['clone-with-rvt-button'].$el.focus()
        } else if (this.$refs['clone-button']) {
            this.$refs['clone-button'].$el.focus()
        }
    },

    methods: {
        handleClose() {
            this.modalStore.setClose()
        },

        async handleCloneWithRVT() {
            if (this.executing) return
            this.executing = true
            try {
                await this.unitTypeStore.clone(true)
                this.handleClose()
            } catch (error) {
                console.error('Error cloning unit type with RVT:', error)
            } finally {
                this.executing = false
            }
        },

        async handleCloneWithoutRVT() {
            if (this.executing) return
            this.executing = true
            try {
                await this.unitTypeStore.clone(false)
                this.handleClose()
            } catch (error) {
                console.error('Error cloning unit type without RVT:', error)
            } finally {
                this.executing = false
            }
        },

        async handleClone() {
            if (this.executing) return
            this.executing = true
            try {
                await this.unitTypeStore.clone(false)
                this.handleClose()
            } catch (error) {
                console.error('Error cloning unit type:', error)
            } finally {
                this.executing = false
            }
        },
    },
}
</script>

<style scoped>
.confirm-type-clone-wrapper {
    padding: 0;
}
</style>
